export default function Paginacao({ pagina, totalPaginas, onChange }) {
  if (totalPaginas <= 1) return null;

  return (
    <nav className="d-flex justify-content-center mt-3">
      <div className="filter-tabs">
        <button type="button" className="filter-tab" disabled={pagina === 1} onClick={() => onChange(pagina - 1)}>
          Anterior
        </button>
        {Array.from({ length: totalPaginas }, (_, i) => i + 1).map((p) => (
          <button
            key={p}
            type="button"
            className={`filter-tab${p === pagina ? ' is-active' : ''}`}
            onClick={() => onChange(p)}
          >
            {p}
          </button>
        ))}
        <button
          type="button"
          className="filter-tab"
          disabled={pagina === totalPaginas}
          onClick={() => onChange(pagina + 1)}
        >
          Próxima
        </button>
      </div>
    </nav>
  );
}
